"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuizResultPage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const fetch_result_renderer_1 = require("../../../component/fetch-result-renderer");
const use_lazy_promise_1 = require("../../../hook/use-lazy-promise");
const quiz_1 = require("../../../network/quiz");
const react_router_dom_1 = require("react-router-dom");
const quiz_result_renderer_1 = require("./quiz-result-renderer");
const log_view_layout_1 = require("../../../component/log-view-layout");
const log_1 = require("../../../model/log");
exports.QuizResultPage = (0, react_1.memo)(() => {
    const { id } = (0, react_router_dom_1.useParams)();
    const { result, status, error, executeWithVerify } = (0, use_lazy_promise_1.useLazyPromise)(quiz_1.getQuizResult);
    const navigate = (0, react_router_dom_1.useNavigate)();
    (0, react_1.useEffect)(() => {
        executeWithVerify(() => {
            if (!id) {
                throw new Error("Cannot find quiz result");
            }
            return [id];
        });
    }, [executeWithVerify, id]);
    const onReQuiz = (0, react_1.useCallback)(() => {
        if (id) {
            navigate(`/requiz/${id}`);
        }
    }, [id, navigate]);
    const onGoToList = (0, react_1.useCallback)(() => {
        navigate("/list");
    }, [navigate]);
    return ((0, jsx_runtime_1.jsx)(log_view_layout_1.LogViewLayout, { eventName: log_1.LogEventViewName.QuizResultPage, children: (0, jsx_runtime_1.jsx)(fetch_result_renderer_1.FetchResultRenderer, { result: result, status: status, errorMessages: error === null || error === void 0 ? void 0 : error.message, sx: {
                flex: 1,
            }, children: (data) => ((0, jsx_runtime_1.jsx)(quiz_result_renderer_1.QuizResultRenderer, { result: data, onReQuiz: onReQuiz, onGoToList: onGoToList })) }) }));
});
exports.QuizResultPage.displayName = "QuizResultPage";
exports.default = exports.QuizResultPage;
